module.exports = __webpack_public_path__ + "img/6.e43d64fa.png";